import { Badge, type BadgeProps } from "@/components/ui/badge";
import type { User } from "@/lib/api-types";

/** Map a user_status to a badge tone. DELETED/INACTIVE/SUSPENDED read as muted/danger. */
export function StatusBadge({ status }: { status: User["user_status"] }) {
  const tone: BadgeProps["tone"] =
    status === "ACTIVE" ? "success" : status === "DELETED" ? "danger" : "neutral";
  return <Badge tone={tone}>{status}</Badge>;
}

/** Map a role_id to a badge tone. SUPER_ADMIN highlighted with the brand tone. */
export function RoleBadge({ role }: { role: User["role_id"] }) {
  const tone: BadgeProps["tone"] = role === "SUPER_ADMIN" ? "brand" : "neutral";
  return <Badge tone={tone}>{role}</Badge>;
}
